import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../../../material.module';
import { SliderComponent } from './slider.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [SliderComponent],
  exports: [SliderComponent]
})
export class SliderModule {}
